var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelhi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.419,
    height: 53.097,
    viewBox: "0 0 55.419 53.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11921",
    "data-name": "Group 11921",
    transform: "translate(-490.976 25.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20294",
    "data-name": "Path 20294",
    d: "M490.976,9.1V8.341a21.212,21.212,0,0,1,.664-4.195A22.13,22.13,0,0,1,501.645-9.379c.567-.351,1.127-.714,1.7-1.059a1.649,1.649,0,0,0,.565-.639,38.738,38.738,0,0,1,4.881-6.73,40.824,40.824,0,0,1,6.837-6.111,7.218,7.218,0,0,1,1.813-1.061,3.883,3.883,0,0,1,3.6.565,43.672,43.672,0,0,1,5.088,4.1,43.379,43.379,0,0,1,6.217,7.385,9.552,9.552,0,0,1,.724,1.2A4.2,4.2,0,0,0,534.9-9.887a24.135,24.135,0,0,1,5.256,4.041,22.135,22.135,0,0,1,4.914,7.878,23.338,23.338,0,0,1,1.177,4.6c.092.6.039,1.215.152,1.814V9.1c-.067.06-.053.14-.056.217s-.011.157.056.216v1.3c-.071.065-.052.151-.056.232q0,.093,0,.187c0,.081-.015.167.056.231v.649A24.581,24.581,0,0,1,545.2,18.2c-.091.3.023.384.308.385s.619-.074.885.146v8.984a.814.814,0,0,1-.555.172c-.18.007-.361.005-.541.005q-26.613,0-53.226,0a1.6,1.6,0,0,1-1.1-.174V18.732a.854.854,0,0,1,.614-.15c.676-.018.672-.016.485-.691-.336-1.217-.674-2.433-.9-3.678-.124-.691-.062-1.4-.2-2.083V11.48c.071-.065.052-.151.056-.232q0-.093,0-.187c0-.081.015-.167-.056-.231v-1.3c.067-.06.053-.14.056-.217S491.043,9.158,490.976,9.1Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20295",
    "data-name": "Path 20295",
    d: "M490.976,281.728c.106.038.1.124.094.212-.029.054-.06.053-.094,0Z",
    transform: "translate(0 -272.63)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20296",
    "data-name": "Path 20296",
    d: "M490.976,297.229a.182.182,0,0,1,.093.221c-.033.043-.064.044-.093,0Z",
    transform: "translate(0 -286.399)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20297",
    "data-name": "Path 20297",
    d: "M986.118,297.45a.182.182,0,0,1,.093-.221v.216Q986.168,297.516,986.118,297.45Z",
    transform: "translate(-439.817 -286.399)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20298",
    "data-name": "Path 20298",
    d: "M490.976,299.166l.093,0q0,.108,0,.216c-.032.044-.063.044-.092,0Z",
    transform: "translate(0 -288.119)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20299",
    "data-name": "Path 20299",
    d: "M986.156,299.17l.093,0v.217c-.029.048-.059.047-.092,0Q986.157,299.278,986.156,299.17Z",
    transform: "translate(-439.854 -288.119)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20300",
    "data-name": "Path 20300",
    d: "M490.976,301.1l.092,0c.013.09.024.179-.092.213Z",
    transform: "translate(0 -289.841)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20301",
    "data-name": "Path 20301",
    d: "M986.108,301.108l.092,0v.216C986.083,301.286,986.095,301.2,986.108,301.108Z",
    transform: "translate(-439.805 -289.841)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20302",
    "data-name": "Path 20302",
    d: "M490.976,283.632l.094,0a.182.182,0,0,1-.094.221Z",
    transform: "translate(0 -274.317)",
    fill: "#3a3a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20303",
    "data-name": "Path 20303",
    d: "M986.118,281.94c-.009-.089-.013-.175.094-.212v.217Q986.162,282.019,986.118,281.94Z",
    transform: "translate(-439.818 -272.63)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20304",
    "data-name": "Path 20304",
    d: "M986.111,283.628l.094,0v.216A.182.182,0,0,1,986.111,283.628Z",
    transform: "translate(-439.81 -274.317)",
    fill: "#3a3a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20305",
    "data-name": "Path 20305",
    d: "M779.339,151.669a48.154,48.154,0,0,0,1.429-7.414c.343-2.91.308-5.83.393-8.79.267.47.541.936.8,1.411a39.542,39.542,0,0,1,2.013,4.236c.136.341.267.365.582.237,1.255-.513,1.269-.507.718-1.768a46.571,46.571,0,0,0-2.422-4.76c.162-.091.232.056.321.116a17.045,17.045,0,0,1,6.788,10.016,26.027,26.027,0,0,1-.367,14.965c-.069.223-.124.451-.191.675-.03.1-.053.236-.185.228-.159-.01-.1-.158-.11-.253-.009-.162,0-.325,0-.487a53.647,53.647,0,0,0-.548-9.222,50.193,50.193,0,0,0-1.65-6.98c-.077-.247-.187-.3-.426-.211-.434.167-1.058.19-1.266.5-.219.326.176.86.306,1.3a46.146,46.146,0,0,1,1.811,13.557c0,.469-.021.939.006,1.407.02.342-.091.472-.428.39a.786.786,0,0,1-.3-.224,47.512,47.512,0,0,0-7.043-8.5C779.451,151.987,779.242,151.905,779.339,151.669Z",
    transform: "translate(-256.123 -142.11)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20306",
    "data-name": "Path 20306",
    d: "M598.987,160.775c-.337.082-.423-.051-.429-.39A47.239,47.239,0,0,1,600.68,144.5c.106-.319.064-.483-.29-.564-.419-.1-.9-.436-1.22-.318-.348.126-.323.743-.446,1.148a45.4,45.4,0,0,0-1.931,13.373c0,.776,0,1.551,0,2.327,0,.107.081.282-.108.306-.13.017-.155-.126-.186-.226a27.329,27.329,0,0,1-1.263-12.2,22.8,22.8,0,0,1,2.7-8.312,15.255,15.255,0,0,1,5.072-5.291c-.661,1.266-1.347,2.516-1.937,3.812-.291.638-.552,1.289-.848,1.924-.109.235-.079.323.169.437,1.333.612,1.323.619,1.886-.689a41.579,41.579,0,0,1,2.469-4.816.557.557,0,0,1,.072.425,63.809,63.809,0,0,0,.43,9.448,44.621,44.621,0,0,0,1.305,6.34c.021.211-.13.33-.258.451a47.908,47.908,0,0,0-7.014,8.484A.82.82,0,0,1,598.987,160.775Z",
    transform: "translate(-92.404 -142.062)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20307",
    "data-name": "Path 20307",
    d: "M632.322,42.975a44.806,44.806,0,0,1,3.577-4.912c1.184-1.426,2.522-2.7,3.807-4.032l1.506-1.295a3.454,3.454,0,0,1,1.223-1.121,1.523,1.523,0,0,0,.667-1.424q-.021-13.381-.01-26.761a3.3,3.3,0,0,1,.083-.965c.051-.061.128-.181.175-.039a1.577,1.577,0,0,1,.02.482q0,13.764,0,27.528v.716c.595-.671,1.14-.794,1.734.085v-.8q0-13.764,0-27.528a1.585,1.585,0,0,1,.02-.482c.047-.141.124-.022.175.039a3.3,3.3,0,0,1,.083.965q0,13.3-.015,26.6a1.782,1.782,0,0,0,.845,1.718,2.642,2.642,0,0,1,1.051.989l1.5,1.3c1,1.058,2.07,2.039,3.03,3.133a43.567,43.567,0,0,1,4.356,5.808c-.06.318-.314.167-.471.168-1.861.012-3.722.007-5.581.008-.355.035-.5-.221-.652-.471a16.465,16.465,0,0,0-2.667-3.387,19.891,19.891,0,0,0-2.033-1.692.754.754,0,0,0-1.016-.007,16.842,16.842,0,0,0-4.706,5.075c-.151.25-.289.512-.649.482-1.864,0-3.726,0-5.589-.008C632.636,43.142,632.382,43.293,632.322,42.975Z",
    transform: "translate(-125.554 -24.475)",
    fill: "#04a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20308",
    "data-name": "Path 20308",
    d: "M682.523,3.3c.181.156.115.368.115.558q0,13.822.011,27.643a.887.887,0,0,1-.406.811c-.571.405-1.123.837-1.683,1.258a42.8,42.8,0,0,1-1.194-6.688c-.411-4.1-.173-8.216-.237-12.324-.009-.578,0-.578-.527-.317l-1.983.987A18.509,18.509,0,0,1,682.523,3.3Z",
    transform: "translate(-164.901 -25.313)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20309",
    "data-name": "Path 20309",
    d: "M749.429,33.578c-.63-.477-1.258-.958-1.892-1.43-.252-.187-.187-.45-.187-.694q0-10.035,0-20.07,0-3.733,0-7.465c0-.207-.078-.438.115-.612a19.075,19.075,0,0,1,5.984,11.967c-.742-.369-1.436-.693-2.107-1.058-.388-.211-.493-.182-.492.3.01,3.047.024,6.1-.025,9.142A41.868,41.868,0,0,1,749.429,33.578Z",
    transform: "translate(-227.717 -25.315)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20310",
    "data-name": "Path 20310",
    d: "M515.426,389.126c-2.667,0-5.335-.009-8,.01-.4,0-.512-.085-.5-.5.028-1.477.022-2.956,0-4.433,0-.358.1-.456.455-.455q8.029.016,16.058,0c.391,0,.477.123.472.489-.019,1.478-.023,2.956,0,4.433.007.394-.118.465-.482.462C520.761,389.119,518.094,389.126,515.426,389.126Z",
    transform: "translate(-14.162 -363.252)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20311",
    "data-name": "Path 20311",
    d: "M827.45,389.118c-2.667,0-5.335-.008-8,.009-.381,0-.476-.1-.47-.475.023-1.477.016-2.956,0-4.433,0-.316.027-.48.427-.479q8.056.022,16.112,0c.378,0,.445.13.442.467-.015,1.5-.021,2.992,0,4.487.006.38-.133.43-.46.428C832.821,389.113,830.135,389.118,827.45,389.118Z",
    transform: "translate(-291.355 -363.244)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20312",
    "data-name": "Path 20312",
    d: "M524.515,126.437c0,2.081,0,4.075-.005,6.069a1,1,0,0,1-.127.406,24.148,24.148,0,0,0-1.922,5.7c-.077.38-.212.518-.625.513-2.288-.024-4.577-.016-6.865-.006-.3,0-.4-.024-.294-.374A20.345,20.345,0,0,1,524.515,126.437Z",
    transform: "translate(-21.016 -134.689)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20313",
    "data-name": "Path 20313",
    d: "M884.832,139.217h-4.793c-.865,0-1.73-.01-2.595.006-.284.005-.394-.075-.458-.37a24.69,24.69,0,0,0-2-5.9,1.129,1.129,0,0,1-.1-.525c0-1.928,0-3.856,0-5.877a20.6,20.6,0,0,1,6.275,5.3A20.926,20.926,0,0,1,884.832,139.217Z",
    transform: "translate(-341.019 -134.788)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20314",
    "data-name": "Path 20314",
    d: "M515.142,262.016a29.605,29.605,0,0,0,1.352,7.8c.15.486,0,.536-.416.521-.81-.029-1.621-.019-2.432-.025a1.247,1.247,0,0,1-.369-.458,15.658,15.658,0,0,0-5.646-5.666c-.139-.082-.259-.192-.4-.265a19.038,19.038,0,0,1,.224-5.809c.179-.121.347-.016.513.033a20.248,20.248,0,0,1,6.685,3.384A1.912,1.912,0,0,1,515.142,262.016Z",
    transform: "translate(-14.328 -251.6)",
    fill: "#04a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20315",
    "data-name": "Path 20315",
    d: "M889.143,270.309c-.847.006-1.694-.009-2.54.027-.433.019-.418-.142-.321-.471a32.19,32.19,0,0,0,1.067-4.623q.229-1.606.3-3.225a11.012,11.012,0,0,1,2.543-1.873,20.268,20.268,0,0,1,4.583-1.983c.181-.056.363-.178.564-.05a19.05,19.05,0,0,1,.223,5.809,19.266,19.266,0,0,0-3.668,2.81,17.514,17.514,0,0,0-2.27,2.936A1.971,1.971,0,0,1,889.143,270.309Z",
    transform: "translate(-351.09 -251.601)",
    fill: "#04a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20316",
    "data-name": "Path 20316",
    d: "M688.241,320.08a18.547,18.547,0,0,1,2.908-3.807,18.963,18.963,0,0,1,2.372-1.954.535.535,0,0,1,.715,0,16.926,16.926,0,0,1,4.964,5.258c.1.169.21.335.316.5.033.022.043.042.03.061s-.024.027-.036.027H688.247q-.053-.026-.038-.057C688.219,320.09,688.23,320.08,688.241,320.08Z",
    transform: "translate(-175.193 -301.457)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20317",
    "data-name": "Path 20317",
    d: "M799.608,45.029a18.236,18.236,0,0,0-2.694-2.762c-.495-.39-1-.771-1.511-1.136a.675.675,0,0,1-.332-.565,20.428,20.428,0,0,0-2.876-9.4,1.139,1.139,0,0,1-.063-.151c.215-.136.294.069.4.165a39.134,39.134,0,0,1,6.951,8.853.872.872,0,0,1,.133.456C799.605,41.947,799.608,43.4,799.608,45.029Z",
    transform: "translate(-267.508 -49.889)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20318",
    "data-name": "Path 20318",
    d: "M618.9,45.071c0-1.653,0-3.127,0-4.6a.775.775,0,0,1,.131-.4,39.3,39.3,0,0,1,6.987-8.895c.085-.081.151-.215.339-.156.028.168-.111.276-.182.4a20.775,20.775,0,0,0-2.736,9.064c-.013.207.034.427-.195.579A18.535,18.535,0,0,0,618.9,45.071Z",
    transform: "translate(-113.631 -49.917)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20319",
    "data-name": "Path 20319",
    d: "M682.094,383.753c2.218,0,4.437.01,6.655-.009.383,0,.512.1.469.48-.048.425.178.986-.087,1.245s-.821.075-1.249.075c-4.148.005-8.3,0-12.445.013-.418,0-.539-.1-.53-.524.027-1.28.007-1.28,1.289-1.28Z",
    transform: "translate(-163.381 -363.247)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20320",
    "data-name": "Path 20320",
    d: "M681.834,417.14c-2.236,0-4.472-.008-6.708.008-.348,0-.476-.08-.444-.44.038-.429-.141-1,.076-1.258.256-.3.847-.095,1.292-.1,4.13-.009,8.26,0,12.389-.017.456,0,.568.116.557.563-.031,1.239-.009,1.239-1.263,1.239Z",
    transform: "translate(-163.151 -391.266)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20321",
    "data-name": "Path 20321",
    d: "M508.2,310.551a2.722,2.722,0,0,1,1.339.708,15.742,15.742,0,0,1,4.98,5.432,1.844,1.844,0,0,1,.1.249c-1.564.006-3.128.01-4.691.021-.179,0-.305-.023-.36-.223A30.187,30.187,0,0,1,508.2,310.551Z",
    transform: "translate(-15.303 -298.232)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20322",
    "data-name": "Path 20322",
    d: "M912.331,316.663a14.214,14.214,0,0,1,2.677-3.688,15.925,15.925,0,0,1,3.308-2.574c.127-.076.245-.232.432-.127a30.191,30.191,0,0,1-1.365,6.187c-.055.2-.182.224-.36.223C915.459,316.673,913.895,316.669,912.331,316.663Z",
    transform: "translate(-374.278 -297.955)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20323",
    "data-name": "Path 20323",
    d: "M517.836,259.968c-.932-.607-1.8-1.3-2.772-1.859a24.561,24.561,0,0,0-4.917-2.049c-.036-.232.057-.314.3-.313q3.645.01,7.29,0c.27,0,.344.083.3.344A26.614,26.614,0,0,0,517.836,259.968Z",
    transform: "translate(-17.022 -249.551)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20324",
    "data-name": "Path 20324",
    d: "M904.951,256.033a21.714,21.714,0,0,0-6.727,3.224,4.937,4.937,0,0,1-.963.682,26.7,26.7,0,0,0-.2-3.88c-.039-.26.032-.346.3-.345q3.648.013,7.3,0C904.9,255.715,904.985,255.806,904.951,256.033Z",
    transform: "translate(-360.705 -249.523)",
    fill: "#fefefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20325",
    "data-name": "Path 20325",
    d: "M637.128,366a.169.169,0,0,1,.006.089h-6.47l.185-.212c.151.19.365.12.554.12Q634.265,366.006,637.128,366Z",
    transform: "translate(-124.08 -347.379)",
    fill: "#eebf6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20326",
    "data-name": "Path 20326",
    d: "M789.364,366.087a.168.168,0,0,1,.006-.088q2.863,0,5.726,0c.189,0,.4.07.554-.121l.185.212Z",
    transform: "translate(-265.047 -347.376)",
    fill: "#eebf6a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelhi);
export default __webpack_public_path__ + "static/media/delhi.90040062947fa6b700c8c99356d0b374.svg";
export { ForwardRef as ReactComponent };